import { useCallback, useContext, useState } from 'react'
import '../assets/css/Prijava.css'
import '../assets/css/ResetPassword.css'
import { Alert, Button, Form, Input } from "antd"
import { addAuthorizationToHeaders, containsANumberAndUppercaseLetter } from '../services/CommonService'
import { Navigate, useNavigate } from 'react-router-dom'
import noRefreshClient, { setMessageBasedOnErrorMessage } from '../services/api/NoRefreshClient'
import { useModalContext } from '../context/ModalContext'
import { CHANGE_PASSWORD_OK_RESPONSE, MODAL_DESCRIPTION_ERROR_UNAUTHORIZED, MODAL_DESCRIPTION_SUCCESS_CHANGE_PASSWORD, MODAL_MESSAGE_ERROR, MODAL_MESSAGE_SUCCESS_REQUEST, MODAL_TYPE_ERROR, MODAL_TYPE_SUCCESS } from '../HistoriografijaConstants'
import UserContext from '../context/UserContext'
import { logoutUser } from '../services/UserService'

function ChangePassword() {
    const [showWarning, setShowWarning] = useState(false)
    const [error, setError] = useState(String)
    const [form] = Form.useForm()
    const { displayMessageModalWithParameters, displayGenericErrorModal, resetModalContext } = useModalContext()
    const { userId, clearUserContext } = useContext(UserContext)

    const navigate = useNavigate()

    const submitForm = (values) => {
        form.validateFields({validateOnly: true})
        .then(async () => {
            return addAuthorizationToHeaders({})
            .then(async headers => {
                headers["Content-Type"] = "application/json";
                var formData = new FormData();
                formData.append("oldPassword", values.oldPassword)
                formData.append("newPassword", values.newPassword)
                formData.append("confirmPassword", values.confirmPassword)
                formData.append("userId", userId)
                return noRefreshClient.put('users/changePassword', formData, { headers })
                    .then(data => {
                        if (data.status === 200) {
                            if (data.data === CHANGE_PASSWORD_OK_RESPONSE) {
                                displayMessageModalWithParameters(MODAL_MESSAGE_SUCCESS_REQUEST, MODAL_DESCRIPTION_SUCCESS_CHANGE_PASSWORD, MODAL_TYPE_SUCCESS)
                                logoutUser()
                                .then(data => {
                                    clearUserContext()
                                })
                                // Logout
                                logoutUser()
                                    .then(data => {
                                        clearUserContext()
                                    })
                                // Redirect the user to home page after 5 seconds
                                setTimeout(() => {
                                    navigate('/')
                                    resetModalContext()
                                }, 5000)
                            }
                        } else {
                            displayGenericErrorModal()
                            form.resetFields()
                        }
                    })
                    .catch(error => {
                        if (error?.response?.status === 401) {
                            displayMessageModalWithParameters(MODAL_MESSAGE_ERROR, MODAL_DESCRIPTION_ERROR_UNAUTHORIZED, MODAL_TYPE_ERROR)
                            logoutUser()
                                .then(data => {
                                    clearUserContext()
                                })
                            // Redirect the user to home page after 5 seconds
                            setTimeout(() => {
                                navigate('/')
                                resetModalContext()
                            }, 5000)
                        } else if (error?.response?.status === 400) {
                            setMessageBasedOnErrorMessage(error)
                            setError(error.message)
                            setShowWarning(true)
                        } else {
                            displayGenericErrorModal()
                            form.resetFields()
                        }
                    })
            })
            .catch(error => {
                displayGenericErrorModal()
                form.resetFields()
            })
        })
    }

    const goToStartPage = useCallback(() => {
        navigate("/")
    }, [navigate])

    return (
        userId ?
        <div className="Prijava centered-narrow-div">
                <div className="PrijavaForm">
                    <Form form={form} onFinish={submitForm} className="Form" noValidate scrollToFirstError>
                        <h2 className="FormTitle">PROMJENA LOZINKE</h2>

                        <Form.Item name="oldPassword"
                            className="formItem"                         
                            rules={[
                                {
                                    required: true,
                                    message: 'Trenutna lozinka je obavezno polje',
                                }
                            ]}>
                            <Input.Password
                                type="password"
                                placeholder="Unesite trenutnu lozinku"
                                className="inputField"
                            />
                        </Form.Item>

                        <Form.Item name="newPassword"
                            className="formItem"                         
                            rules={[
                                () => ({
                                    validator(_, value) {
                                        if (value) {
                                            if (value.length !== 0 && value.length < 8) {
                                                return Promise.reject(new Error('Lozinka je prekratka. Potrebno je da ima najmanje 8 karaktera'))
                                            } else if (value.length > 30) {
                                                return Promise.reject(new Error('Lozinka je preduga'))
                                            } else if (!containsANumberAndUppercaseLetter(value)) {
                                                return Promise.reject(new Error('Lozinka treba da sadrži najmanje 1 broj i najmanje 1 veliko slovo'))
                                            }
                                            return Promise.resolve()
                                        }
                                        return Promise.reject(new Error('Lozinka je obavezno polje'))
                                    },
                                })
                            ]}
                        >
                            <div>
                                <Input.Password
                                    type="password"
                                    placeholder="Nova lozinka"
                                    className="inputField"
                                />
                                <p className="field-description">Lozinka treba da sadrži najmanje 8 karaktera, 1 broj, 1 veliko slovo</p>
                            </div>
                        </Form.Item>

                        <Form.Item name="confirmPassword"
                            className="formItem"                         
                            rules={[
                                {
                                    required: true,
                                    message: 'Potvrdite novu lozinku',
                                },
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        if (!value || getFieldValue('newPassword') === value) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(new Error('Lozinke se ne slažu'));
                                    },
                                })
                        ]}>
                            <Input.Password
                                type="password"
                                placeholder="Potvrdite novu lozinku"
                                className="inputField"
                            />
                        </Form.Item>

                        {showWarning ?
                            <Alert
                                message="Greška"
                                description={error}
                                type="error"
                                style={{ marginBottom: '20px', marginTop: '20px' }}
                                showIcon
                            /> : null
                        }

                        <Form.Item>
                            <Button htmlType="submit" className="login-form-button custom-button primaryButton">
                                RESETUJ LOZINKU
                            </Button>
                        </Form.Item>

                        <Form.Item>
                            <Button onClick={goToStartPage} className="login-form-button custom-button secondaryButton button-as-link">
                                Povratak na početnu stranicu
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </div>
            :
            <Navigate to="/" replace={true} />
    )
}

export default ChangePassword